// extracted by mini-css-extract-plugin
module.exports = {"ItemsGrid":"Merchandise_ItemsGrid__noKwL","OrdersTable":"Merchandise_OrdersTable__taEsU","OrdersHeader":"Merchandise_OrdersHeader__2o1jd","Controls":"Merchandise_Controls__2jJbt"};